<template>
  <div class="jackpot__mega">
    <div class="jackpot__mega-title">
      <u-i-compressed-image
        v-if="level.image"
        loading="lazy"
        class="jackpot__mega-icon"
        :compressed-images="level.image"
      />
      <span>{{ level.name }}</span>
    </div>
    <animated-number class="jackpot__mega-value" :value="level.amount" :currency="currencyCode" :max="0" />
  </div>
</template>

<script setup>
import AnimatedNumber from 'components/layouts/AnimatedNumber.vue'
import { useSiteInfoStore } from 'src/stores/site-info'
import UICompressedImage from 'components/ui/UICompressedImage.vue'

defineProps({
  level: {
    type: Object,
    default: () => {},
  },
})

const currencyCode = useSiteInfoStore().userCurrency?.code || useSiteInfoStore().defaultCurrency?.code || 'USD'
</script>

<style lang="scss" scoped>
.jackpot__mega {
  &-title {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    color: rgba(255, 255, 255, 0.47);
    font-weight: 500;
    font-size: 12px;
  }

  &-icon {
    width: 16px;
    height: 16px;
  }

  &-value {
    font-size: 30px;
    font-weight: 800;
    color: #fff;
    text-shadow: 1px 1px 12px rgba(0, 0, 0, 0.32);
    line-height: 27px;
    margin-top: 5px;
    display: flex;
    justify-content: center;

    span {
      font-size: 24px;
    }
  }
}
</style>
